import { Grid, MenuItem } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { FormikCurrencyField } from "../../products/components/FormikCurrencyField"
import { FormikDropdown } from "../../../../../shared/components/forms/Formik"
import { TranslationKey } from "../../../../localization/translations"

type PriceWithCurrencyProps = Readonly<{
    priceName: "minimumPrice" | "maximumPrice" | "pricePerSeat" | "defaultPrice"
    currencyName: "minimumPriceCurrency" | "maximumPriceCurrency" | "pricePerSeatCurrency" | "defaultCurrency"
    priceLabelId: TranslationKey
    priceFallbackLabel: string
    currencyLabelId: TranslationKey
    currencies?: readonly string[]
}>

const DEFAULT_CURRENCIES = ["DKK"] as const

export function PriceWithCurrency({
    priceName,
    currencyName,
    priceLabelId,
    priceFallbackLabel,
    currencyLabelId,
    currencies = DEFAULT_CURRENCIES,
}: PriceWithCurrencyProps) {
    return (
        <Grid container item spacing={1} direction="row">
            <Grid item sm={3}>
                <LocalizedStrict id={priceLabelId} attrs={{ label: true }}>
                    <FormikCurrencyField name={priceName} label={priceFallbackLabel} />
                </LocalizedStrict>
            </Grid>
            <Grid item sm={2.5}>
                <LocalizedStrict id={currencyLabelId} attrs={{ label: true }}>
                    <FormikDropdown name={currencyName} label="Currency" fullWidth>
                        {currencies.map((c) => (
                            <MenuItem key={c} value={c}>
                                {c}
                            </MenuItem>
                        ))}
                    </FormikDropdown>
                </LocalizedStrict>
            </Grid>
        </Grid>
    )
}
